<template>
  <div class="detail">
    <div class="ym_header bg2" style="height: 280px;">
      <div style="height: 200px;width: 1200px;margin: 0 auto;display: flex;align-items: center">
        <div style="height: 149px;width: 500px;float: left;">
          <router-link to="/">
            <img class="ym_logo_img" src="/static/img/logo.png" alt="">
          </router-link>
          <p class="ym_logo_title">双鸭山仲裁委员会</p>
        </div>
      </div>
      <div class="tite_a">
        <div class="tite_b">
          <router-link to="/">网站首页</router-link>
          <router-link to="/about">关于我们</router-link>
          <router-link to="/serveList">仲裁服务</router-link>
          <router-link to="/dynamiList">双仲动态</router-link>
          <router-link to="/messageList">通知公告</router-link>
        </div>
      </div>
    </div>

    <div class="ym_xiang">
      <div class="ym_list_news">
        <div class="ym_list_layout" style="border-radius: 4px;">
          <div class="ym_biaoti" id="ym_biaoti">
            <span style="margin-left: 0px;">
              <i class="layui-icon layui-icon-location"></i>
              <router-link class="sy_title" to="/"> 首页 ></router-link>&nbsp;
              <i class="layui-icon layui-icon-right" style="color: #ccc;"></i>&nbsp;
              <a href="" style="color: #333;">{{ article.title }}</a>
            </span>
          </div>
          <div style="background: url('/static/img/zs_yg_lbImg2.png')left bottom repeat-x;height: 5px;margin: auto;"></div>
          <div class="ym_zcfy_RightCnt" id="bodyTd">
            <h2 class="h2">{{ article.title }}</h2>
            <p style="margin-top: 20px;color: #999;">
              <span>来源：{{ article.source || article.author || '双鸭山仲裁委员会' }}</span>
              <span>发布时间：{{ article.publishDate }}</span>
            </p>
            <div style="height: 20px;border-bottom: 3px solid #f3f7fb;margin: auto;"></div>
            <div class="ym_xqy_div" style="color: #333;text-indent: 2em;line-height: 40px !important;font-size: 18px !important;" v-html="article.content">
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import { getApiUrl, API_CONFIG } from '@/api'

export default {
  name: 'Detail',
  components: { Footer },
  data() {
    return {
      article: {
        title: '',
        content: '',
        publishDate: '',
        source: '',
        author: ''
      }
    }
  },
  mounted() {
    this.loadArticleDetail()
  },
  watch: {
    '$route'() {
      this.loadArticleDetail()
    }
  },
  methods: {
    async loadArticleDetail() {
      const id = this.$route.query.id
      if (!id) return
      
      try {
        const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.ARTICLE_DETAIL, `/${id}`))
        const result = await response.json()
        
        if (result.code === 0 && result.data) {
          this.article = result.data
        }
      } catch (error) {
        console.error('加载文章详情失败:', error)
      }
    }
  }
}
</script>

<style scoped>
@import '../assets/styles.css';

img {
  min-width: auto;
  min-height: auto;
}

.ym_biaoti {
  background-image: linear-gradient(to right, #fff, #fff);
  border: 0;
  color: #125db2;
}

.sy_title:hover {
  color: #409eff;
}

.h2 {
  padding-top: 50px;
  margin: 0px 0px 0px 0px;
  font-size: 24px;
  color: #333;
}

.ym_xqy_div img {
  max-width: 850px;
  max-height: 850px;
  display: block;
  margin: 0 auto;
}

.bg2 {
  background-color: #4d92df;
  background-repeat: no-repeat;
  background-position: top center;
}

.tite_a {
  height: 79px;
  background-color: #125db2;
}

.tite_b {
  width: 1200px;
  height: 74px;
  margin: 0 auto;
}

.tite_a a {
  display: inline-block;
  font-size: 20px;
  color: #fff;
  line-height: 79px;
  padding: 0 76px;
  letter-spacing: 2px;
  float: left;
  font-weight: 600;
  height: 79px;
  text-decoration: none;
}

.tite_a a:hover {
  background-color: #2a6eba;
}

.ym_logo_img {
  width: 80px;
  margin: 33px 20px 0 0;
  float: left;
}

.ym_logo_title {
  font-size: 42px;
  margin: 43px 20px 0 0;
  color: #fff;
  font-weight: 600;
}
</style>